import GooglePlacesAPI from '../../../api/GooglePlacesAPI'

const GooglePlacesInstance = new GooglePlacesAPI();

export default GooglePlacesInstance;
